import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12l18 0","key":"svg-0"}],["path",{"d":"M7 16l10 0l-10 5l0 -5","key":"svg-1"}],["path",{"d":"M7 8l10 0l-10 -5l0 5","key":"svg-2"}]]

const IconFlipHorizontal = createReactComponent('outline', 'flip-horizontal', 'FlipHorizontal', __iconNode);

export default IconFlipHorizontal;